import React from 'react';
import { SurgeonEventProps } from '@components/SchedulePage/SurgeonEvent/SurgeonEventProps';
import { GapDisplay } from '@components/SchedulePage/SurgeonEvent/GapDisplay/GapDisplay';
import { SecondarySurgeonEvent } from '@components/SchedulePage/SurgeonEvent/SecondarySurgeonEvent/SecondarySurgeonEvent';
import { BlockEvent } from '@components/SchedulePage/SurgeonEvent/BlockEvent/BlockEvent';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';

export const SurgeonEvent: React.FC<SurgeonEventProps> = ({ eventInfo, displayMenu = true }) => {
	const { wShowSecondarySurgeon } = useSsmUiFlags();
	return (
		<>
			{eventInfo.isSecondary && wShowSecondarySurgeon && <SecondarySurgeonEvent eventInfo={eventInfo} />}
			{(!eventInfo.isSecondary || !wShowSecondarySurgeon) &&
				<BlockEvent eventInfo={eventInfo} displayMenu={displayMenu} />
			}
			{eventInfo.gapAfterDisplay && <GapDisplay gapDetails={eventInfo.gapAfterDisplay} />}
		</>
	);
};
